<template>
  <v-row class="equipe-info-panel">
    <!-- user profile -->
    <v-col cols="12">
      <v-card class="pt-10">
        <v-card-text class="d-flex justify-center">
          <v-icon
            size="100"
          >
            {{ icons.mdiAccountGroup }}
          </v-icon>
        </v-card-text>

        <v-card-title class="justify-center flex-column">
          <v-chip
            label
            :class="`v-chip-light-bg text-lg font-weight-semibold ${equipeData.nome}--text text-capitalize`"
          >
            {{ equipeData.nome }}
          </v-chip>
        </v-card-title>

        <v-card-text>
          <h2 class="text-lg font-weight-semibold mb-2 mt-2">
            Informações da equipe
          </h2>

          <v-divider></v-divider>

          <v-list>
            <v-list-item
              dense
              class="px-0 mb-n2"
            >
              <span class="font-weight-medium text-no-wrap me-2">Status:</span>
              <span class="text--secondary">{{ equipeData.ativo ? "Ativa": "Inativa" }}</span>
            </v-list-item>
            <v-list-item
              dense
              class="px-0 mb-n2"
            >
              <span class="font-weight-medium text-no-wrap me-2">Gestor Principal:</span>
              <span class="text--secondary">{{ equipeData.nomeGestorPrincipal }}</span>
            </v-list-item>

            <v-list-item
              dense
              class="px-0 mb-n2"
            >
              <span class="font-weight-medium text-no-wrap me-2">Descrição:</span>
              <span class="text--secondary">{{ equipeData.descricao }}</span>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
            v-if="!equipeData.ativo && !acessoPut"
            color="primary"
            class="me-3"
            disabled
          >
            Editar
          </v-btn>
          <v-btn
            v-else
            color="primary"
            class="me-3"
            @click="isInfoDialogOpen = !isInfoDialogOpen"
          >
            Editar
          </v-btn>
          <v-btn
            outlined
            :to="{ name: 'equipes' }"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>

      <equipe-info-edit
        :key="equipeData.id"
        :equipe-data="equipeData"
        :gestores="gestores"
        :is-info-dialog-open.sync="isInfoDialogOpen"
        @refresh-data="$emit('refresh-data')"
      ></equipe-info-edit>
    </v-col>
  </v-row>
</template>

<script>
import { avatarText, kFormatter } from '@core/utils/filter'
import {
  mdiBriefcaseVariantOutline, mdiCheck, mdiCheckboxBlankCircle, mdiAccountGroup,
} from '@mdi/js'
import { ref } from '@vue/composition-api'
import EquipeInfoEdit from './EquipeInfoEdit.vue'

export default {
  components: {
    EquipeInfoEdit,
  },

  props: {
    equipeData: {
      type: Object,
      default: () => { },
    },
    gestores: {
      type: Array,
      default: () => [],
    },
    acessoPut: {
      type: Boolean,
      default: true,
    },
  },

  setup() {
    const isInfoDialogOpen = ref(false)

    return {
      avatarText,
      kFormatter,
      isInfoDialogOpen,
      icons: {
        mdiCheck,
        mdiBriefcaseVariantOutline,
        mdiCheckboxBlankCircle,
        mdiAccountGroup,
      },
    }
  },
}
</script>
